import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { Emitter } from 'vscode/vscode/vs/base/common/event';
import { Disposable, toDisposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { IEditorService } from 'vscode/vscode/vs/workbench/services/editor/common/editorService.service';
import 'vscode/vscode/vs/platform/instantiation/common/instantiation';

let WorkingCopyEditorService = class WorkingCopyEditorService extends Disposable {
    constructor(editorService) {
        super();
        this.editorService = editorService;
        this._onDidRegisterHandler = this._register(( new Emitter()));
        this.onDidRegisterHandler = this._onDidRegisterHandler.event;
        this.handlers = ( new Set());
    }
    registerHandler(handler) {
        this.handlers.add(handler);
        this._onDidRegisterHandler.fire(handler);
        return toDisposable(() => this.handlers.delete(handler));
    }
    findEditor(workingCopy) {
        for (const editorIdentifier of this.editorService.getEditors(0 )) {
            if (this.isOpen(workingCopy, editorIdentifier.editor)) {
                return editorIdentifier;
            }
        }
        return undefined;
    }
    isOpen(workingCopy, editor) {
        for (const handler of this.handlers) {
            if (handler.isOpen(workingCopy, editor)) {
                return true;
            }
        }
        return false;
    }
};
WorkingCopyEditorService = ( __decorate([
    ( __param(0, IEditorService))
], WorkingCopyEditorService));

export { WorkingCopyEditorService };
